import { render, staticRenderFns } from "./bancoDetalhes.vue?vue&type=template&id=8a8f413a&scoped=true&"
import script from "./bancoDetalhes.vue?vue&type=script&lang=js&"
export * from "./bancoDetalhes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8f413a",
  null
  
)

export default component.exports